import { THEME_TOGGLE } from '../constants/ActionTypes';

export const toggleTheme = () => (dispatch) => {
  dispatch({
    type: THEME_TOGGLE,
  });
};
